import { Styles, Theme } from 'assets/types';

const leadListTableViewStyles: Styles = theme => ({
  listContainer: {
    overflow: 'scroll',
    height: '100%',
    padding: 24,
    paddingTop: 0,
  },
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 8px',
  },
  root: {
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    backgroundColor: theme.palette.background.paper,
  },
  loadMoreButton: {
    textAlign: 'center',
  },
  hover: {
    '&$hover:hover': {
      transition: 'all 0.3s ease',
      backgroundColor: (theme as Theme).palette.background.lightPaper,
    },
  },
  selected: {
    '&$selected': {
      transition: 'all 0.3s ease',
      backgroundColor: theme.palette.primary.light,
    },
    '&$selected:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  tableCell: {
    borderBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    '&:first-child': {
      borderRadius: '4px 0 0 4px',
    },
    '&:last-child': {
      borderRadius: '0 4px 4px 0',
    },
  },
  headerTableCell: {
    borderBottom: 0,
    paddingTop: 0,
    paddingBottom: 0,
    color: theme.palette.text.secondary,
  },
  noneFoundContainer: {
    border: `2px solid ${theme.palette.background.paper}`,
    borderRadius: 4,
    padding: 20,
  },
  avatarCellBox: {
    position: 'relative',
    display: 'inline-block',
  },
  sharedLead: {
    position: 'absolute',
    bottom: -2,
    right: -6,
    width: 20,
    height: 20,
    borderRadius: 20,
    backgroundColor: '#F04e45',
    textAlign: 'center',
    lineHeight: '20px',
    fontSize: '13px',
    paddingRight: 1,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    border: '1px solid #FFFFFF',
    '& svg': {
      fontSize: 'inherit',
    },
  },
});

export default leadListTableViewStyles;
